import { useEffect, useState } from "react";
import { ChartRecord, ChartType, getColorList } from "../../models/chart_model";
import {
  fetchAuctionData,
  fetchDailyAuctionData,
  fetchDamAnalysisData,
  fetchSnapshots,
  fetchTamData,
} from "../../Rest_api/RestApi";
import { FormatChartData } from "../../components/recharts/functions";
import { ReLineChart } from "../../components/recharts/ReCharts";
import { ReMixChart } from "../../components/recharts/ReMixCharts";
import { ExchangeColors } from "../Dashboard/Exchange3/FormatData";
import { COLOR_CODES, formatDMY, PrimaryColor } from "../../common";
import { DateRangePicker } from "react-date-range";
import { formatDateString } from "../Dashboard/Auction/Auction";
import { set } from "date-fns";
import { SearchBox } from "../../components/Search";
import { DISCOM_LIST } from "./Discom_list";
const INTERVAL = ["time_slot", "snapshot_date", "month", "year"];
// const EXCHANGES = ["IEX", "HPX", "PXIL", "DEEP"];
// [{'product_common': 'DAC'}, {'product_common': 'HP Intra Day'}, {'product_common': 'Daily'}, {'product_common': None}, {'product_common': 'Intra day'}, {'product_common': 'HP DAC'}, {'product_common': 'Monthly'}, {'product_common': 'Weekly'}, {'product_common': 'HP Daily'}, {'product_common': 'HP Monthly'}]
// const PRODUCTS = [
//   "DAM",

//   "RTM",
//   "GDAM",
//     "RA",
//   "DAC",
//   "Daily",
//   "Intra day",
//   "Monthly",
//   "Weekly",
//   "HP Daily",
//   "HP Monthly",
//   "HP Intra Day",
//   "HP DAC",
//   "HP Weekly",

// ];

const GROUP_BY = ["entity"];
const UNIT_KEYS = ["total_price_rs", "total_volume_mwh"];

export const DamAnalysis = () => {
  const [snapshotData, setSnapshotData] = useState<any[]>([]);
  //   const start_date = "2024-01-01";
  //   const end_date = "2024-01-05";
  const [groupBy, setGroupBy] = useState<string[]>([]);
  const [selectedInterval, setSelectedInterval] = useState<string[]>([
    "snapshot_date",
  ]);
  const [chartKeys, setChartKeys] = useState<string[]>([]);
  const [chartData, setChartData] = useState<ChartRecord[]>([]);
  const [selectedDiscom, setSelectedDiscom] = useState<string>("All");
  const [visible, setVisible] = useState(false);
  const [dates, setDate] = useState([
    {
      startDate: new Date("2023-07-01"),
      endDate: new Date("2023-07-31"),
      key: "selection",
    },
  ]);
  const [dateRange, setDateRange] = useState(dates[0]);

  useEffect(() => {
    _handleFetchingData(
      dates[0].startDate
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-"),
      dates[0].endDate
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-"),
      selectedDiscom
    );
  }, [dates, selectedDiscom]);

  useEffect(() => {
    _handleChartDataChange();
  }, [snapshotData, selectedInterval, groupBy]);

  const _handleFetchingData = async (
    start_date: string,
    end_date: string,
    entity: string
  ) => {
    setSnapshotData(
      await fetchDamAnalysisData({
        startDate: start_date,
        endDate: end_date,
        entity: entity,
      })
    );
  };

  const _handleChartDataChange = () => {
    let data = snapshotData;

    const chartDatas = FormatChartData({
      keys: selectedInterval,
      groupBy: groupBy,
      aggregationKeys: [
        "credit_mwh",
        "debit_mwh",
        "total_price_rs",
        "total_volume_mwh",
      ],
      priceKey: "loss_rs",
      volumeKey: "loss_rs",
      data: data,
    });
    // console.log(chartDatas);
    setChartData(chartDatas.data as any);
    setChartKeys(chartDatas.unit_keys);
  };

  const _handleGroupByChange = (group: string) => {
    if (groupBy.includes(group)) {
      setGroupBy(groupBy.filter((e) => e !== group));
    } else {
      setGroupBy([...groupBy, group]);
    }
  };
  const handleIntervalSelection = (keyIndex: number) => {
    // const selectedKey = keys[keyIndex]; // The key to be toggled
    // const isSelected = selectedKeys.find(
    //   (item) => item.key === selectedKey.key
    // ); // Check if the key is already selected

    // if (isSelected) {
    //   // If the key is already selected and there are more than one keys selected, remove it
    //   if (selectedKeys.length > 1) {
    //     setSelectedKeys(
    //       selectedKeys
    //         .filter((item) => item.key !== selectedKey.key)
    //         .sort((a, b) => a.index - b.index)
    //     );
    //   }
    // } else {
    //   // If the key is not selected and there are less than 2 keys selected, add it
    //   if (selectedKeys.length < 2) {
    //     setSelectedKeys(
    //       [...selectedKeys, selectedKey].sort((a, b) => a.index - b.index)
    //     );
    //   } else {
    //     // If 2 keys are already selected, remove the first key and add the new key
    //     setSelectedKeys(
    //       [selectedKeys[1], selectedKey].sort((a, b) => a.index - b.index)
    //     );
    //   }
    // }
    const interval = INTERVAL[keyIndex];
    const isSelected = selectedInterval.includes(interval);

    if (isSelected) {
      setSelectedInterval(
        selectedInterval
          .filter((e) => e !== interval)
          .sort((a, b) => INTERVAL.indexOf(a) - INTERVAL.indexOf(b))
      );
    } else {
      setSelectedInterval(
        [...selectedInterval, interval].sort(
          (a, b) => INTERVAL.indexOf(a) - INTERVAL.indexOf(b)
        )
      );
    }
  };
  return (
    <div className="flex flex-row w-full h-full">
      <div className="side-filters-container text-nowrap">
        <div></div>

        <div className="side-filter-item">
          <h4>Interval</h4>
          {INTERVAL.map((interval, index) => {
            return (
              <p
                key={interval}
                onClick={() => handleIntervalSelection(index)}
                className={
                  "side-filter-subitem capitalize  " +
                  (selectedInterval.includes(interval)
                    ? "side-filter-subitem  side-filter-subitem-active"
                    : "")
                }
              >
                {interval}
              </p>
            );
          })}
        </div>
        <div className="side-filter-item">
          <h4>Group By</h4>
          {GROUP_BY.map((group) => {
            return (
              <p
                key={group}
                onClick={() => _handleGroupByChange(group)}
                className={
                  "side-filter-subitem capitalize  " +
                  (groupBy.includes(group)
                    ? "side-filter-subitem  side-filter-subitem-active"
                    : "")
                }
              >
                {group}
              </p>
            );
          })}
        </div>
      </div>

      <div className="flex flex-col w-full h-full">
        <div className="markeMonitoring-chart-container">
          <div className="markeMonitoring-chart">
            <div className="date-selection">
              <SearchBox
                options={DISCOM_LIST.map((e) => ({
                  label: e,
                  value: e,
                }))}
                selectedOptions={[
                  { label: selectedDiscom, value: selectedDiscom },
                ]}
                onChange={(e: any) => setSelectedDiscom(e.value)}
                placeholder="Select Discom"
              />
              &nbsp;
              <button
                onClick={() => {
                  setVisible(!visible);
                }}
                className="date-range-button"
              >
                <span className="date-range">
                  {formatDMY(formatDateString(dateRange.startDate))}
                </span>{" "}
                to{" "}
                <span className="date-range">
                  {formatDMY(formatDateString(dateRange.endDate))}
                </span>
              </button>
              {visible && (
                <div
                  className="pop-up-date"
                  onClick={(e) => {
                    setVisible(false);
                  }}
                >
                  <div
                    className="date-selection-wrapper"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <DateRangePicker
                      onChange={(item) => setDate([item.selection as any])}
                      showPreview={true}
                      dragSelectionEnabled={false}
                      minDate={new Date("2022-01-01")}
                      maxDate={new Date("2025-12-31")}
                      moveRangeOnFirstSelection={false}
                      rangeColors={[PrimaryColor, PrimaryColor, PrimaryColor]}
                      months={2}
                      ranges={dates}
                      direction="horizontal"
                    />
                    <button
                      onClick={() => {
                        setDateRange({
                          startDate: new Date(
                            dates[0].startDate
                              .toLocaleDateString("en-GB")
                              .split("/")
                              .reverse()
                              .join("-")
                          ),
                          endDate: new Date(
                            dates[0].endDate
                              .toLocaleDateString("en-GB")
                              .split("/")
                              .reverse()
                              .join("-")
                          ),
                          key: "selection",
                        });
                        setVisible(false);
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              )}
            </div>
            <ReMixChart
              data={chartData}
              showSecondYAxis={true}
              isTimeSlot={false}
              onlyTitle={true}
              yAxisWidth={80}
              xLabel={selectedInterval[0]}
              unit=""
              xDataKey={selectedInterval[0]}
              yAxisLabel="Volume(MWh)"
              secondYAxisLabel="Price(INR)"
              secondYAxisWidth={80}
              secondXAxisLabel={selectedInterval[1]}
              secondXAxisHeight={40}
              xAxisLabelOffset={15}
              xaxisHeight={60}
              secondXDataKey={selectedInterval[1]}
              brushIndex={
                chartData.length > 96
                  ? { startIndex: 0, endIndex: 95 }
                  : {
                      startIndex: 0,
                      endIndex: chartData.length - 1,
                    }
              }
              showBrush={true}
              legends={
                // [
                // {

                //     color: getColorList(2)[0],
                //     dataKey: "total_volume_mwh",
                //     name: "Volume(MWh)",
                //     },
                //     {
                //     color: getColorList(2)[1],
                //     dataKey: "total_price_rs",
                //     name: "Price(INR)",
                //     },

                // ]
                // chartKeys.filter((e)=> e!="loss_rs").map((key, index) => {
                //   return {
                //     color: getColorList(14)[index],
                //     dataKey: "_"+key,
                //     name: key,
                //   };
                // })
                [
                  // "_total_volume_mwh","_total_price_rs","_credit_mwh","_debit_mwh"
                  {
                    color: getColorList(14)[0],
                    dataKey: "_total_volume_mwh",
                    name: "Total Banking(MWh)",
                    yAxisId: "right",
                    type: ChartType.Bar,
                  },
                  {
                    color: getColorList(14)[2],
                    dataKey: "_credit_mwh",
                    name: "Credit(MWh)",
                    yAxisId: "right",
                    type: ChartType.Bar,
                  },
                  {
                    color: getColorList(14)[3],
                    dataKey: "_debit_mwh",
                    name: "Debit(MWh)",
                    yAxisId: "right",
                    type: ChartType.Bar,
                  },
                  {
                    color: getColorList(14)[1],
                    dataKey: "_total_price_rs",
                    name: "Total Savings(INR)",
                  },
                ]
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
